const MAP = {
  LIVE: { c: "bg-bullish/15 text-bullish ring-bullish/30", dot: "bg-bullish", label: "Live" },
  DELAYED: { c: "bg-warning/15 text-warning ring-warning/30", dot: "bg-warning", label: "Delayed" },
  STALE: { c: "bg-warning/15 text-warning ring-warning/30", dot: "bg-warning", label: "Stale" },
  DEMO: { c: "bg-warning/15 text-warning ring-warning/30", dot: "bg-warning", label: "Demo Data" },
  RATE_LIMIT: { c: "bg-warning/15 text-warning ring-warning/30", dot: "bg-warning", label: "Delayed" },
  OFFLINE: { c: "bg-bearish/15 text-bearish ring-bearish/30", dot: "bg-bearish", label: "Unavailable" },
};

export function DataStatusBadge({ status = "DEMO", className = "" }) {
  const s = MAP[status] || MAP.DEMO;
  return (
    <span data-testid="data-status-badge" data-status={status}
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ring-1 ${s.c} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot} ${status === "LIVE" ? "animate-pulse" : ""}`} />
      {s.label}
    </span>
  );
}
